import { Appearance } from 'react-native';

import { ICompanyThemeColors } from '@aqx-core/common/api/config';
import { checkIsNative } from '@aqx-core/common/validators';

import { appThemeViewController } from '../service/controller';
import { EAppThemeMode, EAppThemeScheme, ITenantColors } from '../types';

export const rgba = (rgb: string | undefined, opacity: number) => {
  if (!rgb) {
    return '';
  }

  if (rgb.startsWith('#')) {
    return hexToRgb(rgb, opacity) || '';
  }

  if (!rgb.startsWith('rgb(')) {
    return '';
  }

  return rgb.replace('rgb', 'rgba').replace(')', `, ${opacity})`);
};

export const hexToRgb = (hex: string, opacity?: number) => {
  if (hex.startsWith('rgb')) {
    return hex;
  }

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  if (!result) {
    return null;
  }

  const r = parseInt(result[1], 16);
  const g = parseInt(result[2], 16);
  const b = parseInt(result[3], 16);

  return opacity !== undefined ? `rgba(${r}, ${g}, ${b}, ${opacity})` : `rgb(${r}, ${g}, ${b})`;
};

export const getThemeColors = () => {
  return appThemeViewController.getThemeColors();
};

export const getThemeMode = (themeScheme: EAppThemeScheme) => {
  return themeScheme === EAppThemeScheme.DARK_SCHEME ? EAppThemeMode.DARK : EAppThemeMode.LIGHT;
};

export const formatTenantColors = (companyColors: ICompanyThemeColors): ITenantColors => {
  const { profitColourCode, lossColourCode, themeColourCode } = companyColors;

  return {
    primary: themeColourCode || 'rgb(0, 188, 216)',
    positive: profitColourCode || 'rgb(16, 196, 118)',
    negative: lossColourCode || 'rgb(255, 87, 108)'
  };
};

export const getSystemColorMode = () => {
  if (checkIsNative()) {
    const scheme = Appearance.getColorScheme();
    return scheme === 'dark' ? EAppThemeMode.DARK : EAppThemeMode.LIGHT;
  }

  return window?.matchMedia('(prefers-color-scheme: dark)').matches ? EAppThemeMode.DARK : EAppThemeMode.LIGHT;
};
